var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{class:[
    'delivery-options-list-item',
    `delivery-options-list-item--${_vm.itemStyle}`,
  ]},[_c('div',{staticClass:"icon-container"},[_vm._t("icon")],2),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }